import icon1 from "../../asset/Group 1000003735.png";
import icon2 from "../../asset/Group 1000003736.png";
import icon3 from "../../asset/Group 1000003737.png";

export default function HomeMain2() {
  return (
    <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-[1600px] mx-auto">
        {/* Heading Section */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h1
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[70px] font-bold text-[#0A476C] mb-4 sm:mb-6 leading-tight"
            style={{ fontFamily: '"Futura Bold"' }}
          >
            How We Can Help
          </h1>
          <p
            className="text-base sm:text-lg md:text-xl lg:text-2xl text-[#0A2427] max-w-4xl mx-auto leading-relaxed px-2"
            style={{ fontFamily: '"Avenir Book"' }}
          >
            At Belief Marketing Enterprises, our strategies are designed for law
            firms that want predictable growth and higher-value cases. We do not
            believe in cookie-cutter marketing. We create tailored solutions
            that drive real results.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 xl:gap-12">
          {/* Card 1 */}
          <div className="flex flex-col text-center h-full bg-white rounded-2xl p-6 sm:p-8">
            <div className="w-28 h-28 sm:w-32 sm:h-32 mx-auto mb-6 sm:mb-8 rounded-full flex items-center justify-center">
              <img
                src={icon1}
                alt="SEO & Organic Growth"
                className="w-16 sm:w-20 md:w-24 lg:w-28"
              />
            </div>
            <h2
              className="text-xl sm:text-2xl md:text-3xl lg:text-[35px] font-medium mb-3 sm:mb-4"
              style={{ fontFamily: '"Futura Book"' }}
            >
              SEO & Organic Growth
            </h2>
            <p
              className="text-base sm:text-lg md:text-xl lg:text-[21px] leading-relaxed mb-6 flex-grow"
              style={{ fontFamily: '"Avenir Book"' }}
            >
              We optimize your firm’s website, blogs, and landing pages so
              accident victims searching online find you first. Our SEO
              strategies build long-term visibility and credibility.
            </p>
            <button className="border-2 border-[#FC821F] text-[#FC821F] hover:bg-[#FC821F] hover:text-white font-semibold px-6 sm:px-8 py-2.5 sm:py-3 rounded-xl text-base sm:text-lg transition-colors duration-200">
              Get Help
            </button>
          </div>

          {/* Card 2 */}
          <div className="flex flex-col text-center h-full bg-white rounded-2xl p-6 sm:p-8">
            <div className="w-28 h-28 sm:w-32 sm:h-32 mx-auto mb-6 sm:mb-8 rounded-full flex items-center justify-center">
              <img
                src={icon2}
                alt="Performance Marketing"
                className="w-16 sm:w-20 md:w-24 lg:w-28"
              />
            </div>
            <h2
              className="text-xl sm:text-2xl md:text-3xl lg:text-[35px] font-medium mb-3 sm:mb-4"
              style={{ fontFamily: '"Futura Book"' }}
            >
              Performance Marketing
            </h2>
            <p
              className="text-base sm:text-lg md:text-xl lg:text-[21px] leading-relaxed mb-6 flex-grow"
              style={{ fontFamily: '"Avenir Book"' }}
            >
              From Google to Facebook and YouTube, we run high-performing ad
              campaigns that target accident victims at the moment they are
              looking for legal help, delivering qualified leads directly to
              your firm.
            </p>
            <button className="border-2 border-[#FC821F] text-[#FC821F] hover:bg-[#FC821F] hover:text-white font-semibold px-6 sm:px-8 py-2.5 sm:py-3 rounded-xl text-base sm:text-lg transition-colors duration-200">
              Get Support
            </button>
          </div>

          {/* Card 3 */}
          <div className="flex flex-col text-center h-full bg-white rounded-2xl p-6 sm:p-8">
            <div className="w-28 h-28 sm:w-32 sm:h-32 mx-auto mb-6 sm:mb-8 rounded-full flex items-center justify-center">
              <img
                src={icon3}
                alt="Lead Funnels & Conversion Systems"
                className="w-16 sm:w-20 md:w-24 lg:w-28"
              />
            </div>
            <h2
              className="text-xl sm:text-2xl md:text-3xl lg:text-[35px] font-medium mb-3 sm:mb-4"
              style={{ fontFamily: '"Futura Book"' }}
            >
              Lead Funnels & Conversion Systems
            </h2>
            <p
              className="text-base sm:text-lg md:text-xl lg:text-[21px] leading-relaxed mb-6 flex-grow"
              style={{ fontFamily: '"Avenir Book"' }}
            >
              We run high-performing ad campaigns across Google, Facebook, and
              YouTube to target accident victims and deliver qualified leads.
            </p>
            <button className="border-2 border-[#FC821F] text-[#FC821F] hover:bg-[#FC821F] hover:text-white font-semibold px-6 sm:px-8 py-2.5 sm:py-3 rounded-xl text-base sm:text-lg transition-colors duration-200">
              Get Informed
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
